import { Component } from '@angular/core';
import { AccessService } from '@app-core/services/access/access.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-eula-document',
  templateUrl: './eula-document.component.html',
  styleUrls: ['./eula-document.component.scss'],
})
export class EulaDocumentComponent {
  constructor(private accessService: AccessService) {}

  private loginInfo = this.accessService.getLoginInfo();

  public get showGeneralTemplate(): boolean {
    if (environment.isGeotabEnv) return true;
    return ['platformscience'].includes(this.loginInfo?.customerName);
  }

  public get showSatrackTemplate(): boolean {
    return [
      'satrack',
      'satrackstaging', // for testing
    ].includes(this.loginInfo?.customerName);
  }
}
